let b = 'c-contractor-form';

export default {
  init() {
    this.currentStep = 0;

    this.form = $('#form');
    this.errorClass = `${b}__input--error`;

    this.loadLocalData();

    // get top bar indicators
    this.indicators = $('ul[data-step-indicator]')
      .map((i, el) => {
        return {
          step: $(el).data('step-indicator'),
          el: $(el).find(`.${b}__step-indicator`),
        };
      })
      .toArray();

    // get containers for the different steps
    this.steps = $('section[data-step]')
      .map((i, el) => {
        return {
          step: $(el).data('step').toString().split(','),
          el: $(el),
        };
      })
      .toArray();

    // set up buttons to go to specific steps
    $('[data-step-button]').each((i, el) => {
      $(el).on('click', (event) => {
        event.preventDefault();
        this.goToStep($(el).data('step-button'));
      });
    });

    // show/hide textareas depending on radio button states
    $('[data-bind-group]').each((i, el) => {
      let data = $(el).data('bind-group');
      let observed = $(`[name=${data}]`);
      let input = $(el).find('input, textarea');
      let required = input.attr('required') == 'required';

      let f = () => {
        let o = observed.filter(':checked');
        if (o.val() == 'yes') {
            $(el).show();
            input.attr('required', required);
            input.attr('datas-skip', false);
        }
        else {
            $(el).hide();
            input.attr('required', false);
            input.attr('datas-skip', true);
        }
      };

      observed.on('change', f);
      f();
    });

    // all inputs, to look up type more quickly
    this.inputs = $(':input')
      .map((i, el) => {
        return {
          name: $(el).attr('name'),
          el: $(el),
          type: $(el).attr('type'),
        };
      })
      .toArray();

    // save data to local storage on every input change
    $(':input').each((i, el) => {
      $(el).on('change', () => this.saveLocalData());
    });

    // set up max-length warnings for textareas
    $(':input[maxLength]').map((i, el) => {
      let observed = $(el);
      let span = document.createElement('span');
      span.classList.add(`${b}__maxlength-warning`);

      observed.after(span);
      let maxLength = observed.attr('maxlength');

      let f = () => {
        let remaining = maxLength - observed.val().length;
        if (remaining < maxLength * 0.5) {
          span.innerHTML = `Noch ${remaining} Zeichen verbleibend`;
        } else {
          span.innerHTML = '';
        }
      };

      $(el).on('keyup', f);
      f();
    });

    // different functions to validate input types
    this.validators = new Map([
      [
        'radio',
        (el) => {
          let group = $(`[name=${el.attr('name')}]`);
          return group.filter(':checked').length == 1;
        },
      ],
      ['checkbox', (el) => el.prop('checked')],
      [
        'email',
        // (el) => /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,20}$/i.test(el.val()),
        () => true,
      ],
      [
        'tel',
        (el) =>
          /^([+]?(\d{1,3})\s?)?((\(\d{3,5}\)|\d{3,5})(\s)?)\d{3,9}$/i.test(
            el.val()
          ),
      ],
      ['zip', (el) => /\b\d{5}\b/.test(el.val())],
      ['default', (el) => el.val().trim().length > 0],
    ]);

    // tooltip
    $(`.${b}__tooltip`).each((i, el) => {
      let p = $(el).find('p');
      p.insertAfter(el);

      $(el).on('click', () => {
        $(el).toggleClass(`${b}__tooltip--is-active`);
        $(p).toggle();
      });
    });

    // google maps autocomplete

    this.goToStep(this.currentStep);

    // debug
    window.$ = $;
    window.inputs = this.inputs;
    window.required = this.required;
    window.goToStep = this.goToStep.bind(this);
    window.validateStep = this.validateStep.bind(this);
    window.fillForm = this.fillForm.bind(this);
    window.clearLocalData = this.clearLocalData.bind(this);
  },

  getRequiredFields() {
    return $(':input[required]')
    .map((i, el) => {
      return {
        el: $(el),
        type: $(el).data('type') || $(el).attr('type'),
        step: $(el).closest('[data-step]').data('step'),
        liveCheck: null,
      };
    })
    .toArray();
  },

  // validate all items for a given step
  validateStep(step) {
    let candidates = this.getRequiredFields().filter((item) => item.step == step);
    return candidates.filter((item) => !this.validateItem(item)).length == 0;
  },

  // validate a single item according to 'type'
  validateItem(item) {
    let validator =
      this.validators.get(item.type) || this.validators.get('default');
    let pass = validator(item.el);

    if (pass) item.el.removeClass(this.errorClass);
    else item.el.addClass(this.errorClass);

    if (item.el)
      if (item.liveCheck == null) {
        // once manually checked we add an event for live input checking
        // in the future for all elements with that name
        item.liveCheck = $(`[name=${item.el.attr('name')}]`).on('input', () => {
          this.validateItem(item);
        });
      }

    return pass;
  },

  // find corresponding input and set value
  fillForm(data) {
    data.forEach((item) => {
      let el = $(`[name=${item.name}]:not([data-nosave])`);
      if (el.length < 1) return;

      let type = el.first().attr('type');

      // type: radio
      if (type == 'radio') {
        el.filter(`[value=${item.value}]`).prop('checked', true);
      }
      // type: checkbox
      else if (type == 'checkbox') {
        el.prop('checked', item.value == 'on');
      }
      // default/text
      else el.val(item.value);
    });
  },

  loadLocalData() {
    let data = JSON.parse(window.localStorage.getItem('hwk_contractor_form'));
    this.fillForm(data || []);
  },

  saveLocalData() {
    window.localStorage.setItem(
      'hwk_contractor_form',
      JSON.stringify(this.form.serializeArray())
    );
  },

  clearLocalData() {
    window.localStorage.removeItem('hwk_contractor_form');
  },

  goToStep(step) {
    // if we want to go ahead we have to pass all the the checks
    // check how far we can go and adjust 'step' accordingly
    for (let i = this.currentStep; i < step; i++) {
      if (!this.validateStep(i)) step = i;
      // and scroll to first error occurence
      let error = $(`.${this.errorClass}`).first();
      if (error.length != 0) {
        window.ele = error;
        $('html, body').animate(
          {
            scrollTop: $(error).offset().top - window.innerHeight / 2,
          },
          200
        );
      }
    }

    // show indicators and step container
    this.indicators.forEach((item) => {
      if (item.step == step)
        $(item.el).addClass(`${b}__step-indicator--is-active`);
      else $(item.el).removeClass(`${b}__step-indicator--is-active`);
    });
    this.steps.forEach((item) => {
      if (item.step.includes(step.toString())) $(item.el).show();
      else $(item.el).hide();
    });

    // scroll to top on step change
    if (this.currentStep != step) {
      $('html, body').animate(
        {
          scrollTop: $('#stepper').offset().top - 79,
        },
        200
      );
    }

    this.currentStep = step;
    // this.saveLocalData();

    if (step == 4) {
      this.previewContractor();
      // this.form.submit();
    }

    if (step == 6) {
      this.saveContractor();
      this.form[0].reset();
      this.clearLocalData();
      this.saveLocalData();
    }
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const street = $('#street')[0];
    // const zip = $('#zip-code')[0];
    this.autocomplete = new window.google.maps.places.Autocomplete(street, {
      componentRestrictions: { country: ['de'] },
      fields: ['address_components', 'geometry'],
      types: ['address'],
    });
    this.autocomplete.addListener('place_changed', () => this.fillInAddress());
  },

  fillInAddress() {
    const place = this.autocomplete.getPlace();

    let street,
      number,
      zip;

    (place.address_components || []).forEach((component) => {
      const type = component.types[0];
      if (type == 'route') street = component.short_name;
      if (type == 'street_number') number = component.long_name;
      if (type == 'postal_code') zip = component.long_name;
    });

    if (place.address_components) {
      $('#street').val(`${street || ''} ${number || ''}`);
      $('#zip-code').val(`${zip || ''}`);
    }
  },

  // normalize readio 'yes|no' and checkbox 'on' to 'true|false'
  serializeForm() {
    let data = this.form.serializeArray();
    data = data.flatMap((item) => {
      let input = this.inputs.find((input) => input.name == item.name);

      if(input.el.attr('datas-skip') == 'true') return [];

      if (
        input &&
        input.type == 'radio' &&
        (item.value == 'yes' || item.value == 'no')
      ) {
        item.value = item.value == 'yes';
      }

      if (input && input.type == 'checkbox') {
        item.value = item.value == 'on';
      }

      return [item];
    });
    return data;
  },

  saveContractor() {
    let sendData = {
      dataType: 'json',
      action: 'save_contractor',
      contractor: JSON.stringify(this.serializeForm()),
    };

    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: () => {
        this.goToStep(7);
      },
      error: function () {
        console.log('error');
      },
    });
  },

  previewContractor() {
    let sendData = {
      dataType: 'json',
      action: 'preview_contractor',
      contractor: JSON.stringify(this.serializeForm()),
    };

    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: (response) => {
        $(`.${b}__overview`).html(response);
        this.goToStep(5);
      },
      error: function () {
        console.log('error');
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contractor-form.js